import React, { useState } from "react";
// import { Heading } from "../../../../machinery/styled.components";
import {
  Container,
  LeftSideBar,
  VerticalLine,
  InnerContainer,
  RightContainer,
  InnerRightContainer,
  Card,
  CardInner,
  CardHeading,
  ImagesContainer,
  Img,
  Heading,
  Title,
  InnerCardContainer,
  InnerCardRightContainer,
} from "./styled.components";
import { MobileDropdown } from "./mobiledropDown";
import { useEffect } from "react";
const Seminars = ({ seminars }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 575);

  const [activeSeminar, setActiveSeminar] = useState(seminars[0]?._id);
  const onWindowResize = () => {
    setIsMobile(window.innerWidth <= 575);
  };

  useEffect(() => {
    window.addEventListener("resize", onWindowResize);
    return () => {
      window.removeEventListener("resize", onWindowResize);
    };
  }, []);
  return (
    <>
      <Container>
        <InnerContainer>
          {isMobile ? (
            <MobileDropdown
              seminars={seminars}
              setActiveSeminar={setActiveSeminar}
            />
          ) : (
            <LeftSideBar>
              {seminars.map((seminar_) => {
                return (
                  <Heading
                    style={{
                      color: `${
                        activeSeminar == seminar_._id ? "#F08700" : ""
                      }`,
                    }}
                    onClick={() => setActiveSeminar(seminar_._id)}
                  >
                    {seminar_.name}
                  </Heading>
                );
              })}
            </LeftSideBar>
          )}
          <VerticalLine />
        </InnerContainer>
        <RightContainer>
          <InnerRightContainer>
            {seminars.map((seminar_) => {
              console.log(seminar_);
              if (activeSeminar == seminar_._id) {
                return (
                  <>
                    <Card>
                      <CardInner>
                        <InnerCardContainer>
                          <CardHeading>Name:</CardHeading>
                          <CardHeading>Organization:</CardHeading>
                          <CardHeading>Venue:</CardHeading>
                          {/* <CardHeading>Cost:</CardHeading> */}
                        </InnerCardContainer>
                        <InnerCardRightContainer>
                          <Title>{seminar_.name}</Title>
                          <Title>{seminar_.organization}</Title>
                          <Title>{seminar_.venue}</Title>
                          {/* <Title>{seminar_.amount}</Title> */}
                        </InnerCardRightContainer>
                      </CardInner>
                    </Card>
                    <ImagesContainer>
                      {seminar_.images.map((img_) => {
                        return (
                          <a href={img_}>
                            <Img src={img_} alt="img" />
                          </a>
                        );
                      })}
                    </ImagesContainer>
                  </>
                );
              }
              return;
            })}
          </InnerRightContainer>
        </RightContainer>
      </Container>
    </>
  );
};

export default Seminars;
